// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"fdea0d9d","42":"c711fa2c","139":"9a9ef2ed","154":"5d76fd84","365":"8f193685","395":"c3cd43b7","404":"23de5bdb","460":"12dae8e8","534":"51dc1a4b","602":"06b49066","752":"04697ba3","787":"f0cf388e","900":"664065fe"}[chunkId] + ".chunk.js";
};